import Link from 'next/link';
import React from 'react';
import { Divider } from './Divider';

const FooterDivider = () => <span className="footer-divider mx-2">|</span>

export default function Footer() {

  return (
    <footer>
      <section className="mb-0">
        <p className="text-xs mb-2">Weitere Angebote des Verlags Nürnberger Presse:</p>
        <div className="footer-links">
          <a href="https://www.nordbayern.de" target="_blank" rel="noreferrer">nordbayern</a>
          <FooterDivider />
          <a href="https://www.fein-raus.de" target="_blank" rel="noreferrer">fei(n) raus</a>
          <FooterDivider />
          <a href="https://www.bier.by/" target="_blank" rel="noreferrer">bier.by</a>
        </div>
        <Divider bg="bg-white opacity-20" />
      </section>
      <section>
        <div className="footer-links">
          <Link href="/impressum">Impressum</Link>
          <FooterDivider />
          <Link href="/Jobs">Jobs</Link>
          <FooterDivider />
          <Link href="/datenschutz">Datenschutz</Link>
          <FooterDivider />
          <Link href="/agb">Nutzungsbedingungen/AGB</Link>
          <FooterDivider />
          <Link href="/mediadaten">Mediadaten</Link>
          <FooterDivider />
          <Link href="/abo">Abo</Link>
          <FooterDivider />
          <a href="/cmp">Cookies &amp; Tracking</a>
        </div>
        <p className="mt-4 text-xs">Copyright ©  2021 - Verlag Nürnberger Presse - All rights reserved</p>
      </section>
    </footer>
  );
}